<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isAuctionManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Past Auctions</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
<section class="content">
<!-- main row for all icons  -->
<div class="col-md-12">
	<div class="card card-primary card-outline">
		<div class="card-header">
			<button class="btn btn-secondary float-right" @click="movedata">Sync Bidding History</button>
		</div>
		<div class="card-body overflow-auto">
		<img v-if="auctions==''" src="../images/nodata.svg">
			<datatable style="margin-top:1%;" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy" v-else>
      	<tbody>
        	<tr v-if="auctions!=''" v-for="auction in auctions" :key="auction.id">
        		<td>{{auction.auction_id}}</td>
          	<td>{{auction.name}}</td>
          	<td>{{auction.total_lots}}</td>
          	<td>{{auction.lots_sold}}</td>
          	<td>{{auction.average}}</td>
          	<td>{{auction.lots_withdrawn}}</td>
                <td>{{auction.total_bidders}}</td>
          	<td>{{auction.status}}</td>
          	<td>
          		<button class="btn btn-primary fa fa-info" @click="addModal(auction.id)"></button>&nbsp;
          		<button class="btn btn-secondary fa fa-book" @click="report(auction.id)"></button>&nbsp;
          		<button class="btn btn-secondary fa fa-eye-slash" @click="hide(auction.id)"></button>
          	</td>
          </tr>
        </tbody>
      </datatable>

    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getAuctions(pagination.prevPageUrl)"
        @next="getAuctions(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
</section>
    <!-- /.content -->
<div class="modal" tabindex="-1" role="dialog" id="addModal">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Manage Lots</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      	<table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">Lot Name</th>
      <th scope="col">Quote Price</th>
      <th scope="col">Control Price</th>
      <th scope="col">Highest Bid</th>
        <th scope="col">Total Bidders</th>
      <th scope="col">Status</th>
      <th scope="col">Manage</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(g, index) in auction_lots">
      <th scope="row" >{{g.lot_name}}</th>
      <td>{{g.quote_price}}</td>
      <td>{{g.control_price}}</td>
      <td>{{g.highest_bid_price}}</td>
        <td>{{g.total_bidders}}</td>
      <td>{{g.status}}</td>
      <td>
      	<button class="btn btn-primary fa fa-info" @click="details(g.lot_id)"></button>
      	<button class="btn btn-dark fa fa-cog" @click="alModal(g.id, g.status, g.auction_id)"></button>
      	<button class="btn btn-secondary fa fa-comments" @click="negotiate(g)" v-if="g.status != 'sold'"></button>
      	<button class="btn btn-secondary fa fa-history" @click="history(g.id, g.lot_id)"></button>
      	<button class="btn btn-info fa fa-level-up" @click="autoBidModal(g.id)"></button>
      </td>
    </tr>

  </tbody>
</table>
      </div>
      <div class="modal-footer">
      	<button class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
	</div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="LotStatusModal">
 <div class="modal-dialog" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Change Lot Status</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<select v-model="auctionLotStatus" placeholder="Select a Status">
							<option value="sold">Sold</option>
							<option value="unsold">Unsold</option>
							<option value="withdrawn">Withdrawn</option>
						</select>
					</div>
					<div class="card-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
					<button class="btn btn-primary" @click="changeAuctionLotStatus">Submit</button>
				</div>
				</div>
				</div>
				</div>

<div class="modal" tabindex="-1" role="dialog" id="autoBidModal">
 <div class="modal-dialog" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Auto Bids</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<table class="table table-striped">
  						<thead>
    						<tr>
    							<th scope="col">User</th>
      						<th scope="col">Starting Price</th>
      						<th scope="col">Upper Quote Price</th>
      						<th scope="col">Increment</th>
    						</tr>
  						</thead>
  						<tbody>
    						<tr v-for="(g, index) in auto_bids">
    							<td>{{g.name}}</td>
      						<td>{{g.starting_quote_price}}</td>
      						<td>{{g.upper_quote_price}}</td>
      						<td>{{g.increment}}</td>
    						</tr>
  						</tbody>
						</table>
					</div>
					<div class="card-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
				</div>
				</div>
				</div>

<div class="modal" tabindex="-1" role="dialog" id="sellLotModal">
 <div class="modal-dialog" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Sell Lot</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<table class="table table-striped">
  						<thead>
    						<tr>
      						<th scope="col">Bid Price</th>
      						<th scope="col">Bid Time</th>
      						<th scope="col">Buyer</th>
      						<th scope="col">Sell</th>
    						</tr>
  						</thead>
  						<tbody>
    						<tr v-for="(g, index) in lot_bids">
      						<td>{{g.bid_price}}</td>
      						<td>{{g.bidding_time}}</td>
      						<td>{{g.buyer}}</td>
      						<td>
      							<button class="btn btn-primary fa fa-check-circle" @click="sell(g)"></button>
      						</td>
    						</tr>
  						</tbody>
						</table>
					</div>
					<div class="card-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
				</div>
				</div>
				</div>

	<div class="modal" tabindex="-1" role="dialog" id="negotiateModal">
 <div class="modal-dialog" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Negotiate Lot</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<div class="form-group">
							<input type="number" placeholder="Enter negotiated price" v-model="negotiated_price" min="1" class="form-control">
						</div>
						<div class="form-group">
							<v-select v-model="neg_buyer_id" type="number" label="namephone" :options="buyers" :reduce="buyers => buyers.id" name="neg_buyer_id" placeholder="Select Buyer" :value="buyers => buyers.id"></v-select>
						</div>
					</div>
					<div class="card-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
					<button class="btn btn-primary" @click="sellNegotiatedLot">Sell</button>
				</div>
				</div>
				</div>
				</div>

<div class="modal" tabindex="-1" role="dialog" id="history">
 <div class="modal-dialog" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Bidding History</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<p v-for="(data,index) in bids.slice().reverse()" :key="index"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>  <span style="color: #1fa67a">{{data.bid_price}}</span> was raised by {{data.buyer}}</p>
					</div>
					<div class="card-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
				</div>
				</div>
				</div>

				<br>
      <br>

<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isAuctionManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    import Datatable from '../datatable.vue';
    import Pagination from '../pagination.vue';
    export default {
        mounted() {
            console.log('Component mounted.');
        },

        components: {datatable:Datatable, pagination:Pagination},


        created(){
        	this.getAuctions();
        	this.getBuyers();
        },

    		data(){
        	let sortOrders = {};
      		let columns = [
      			{width:'10%', label:'ID', name:'auction_id'},
      			{width:'10%', label:'Name', name:'name'},
      			{width:'10%', label:'Total Lots', name:'total_lots'},
      			{width:'10%', label:'Lots Sold', name:'lots_sold'},
      			{width:'10%', label:'Average', name:'average'},
      			{width:'10%', label:'Lots Withdrawn', name:'lots_withdrawn'},
                {width:'10%', label:'Total Bidders', name:'total_bidders'},
      			{width:'10%', label: 'Status', name:'status'},
      			{width:'20%', label:'Manage', name:'ops'}
      		];
      		columns.forEach((column) => {
          	sortOrders[column.name]=-1;
        	});
        	return{
        		columns: columns,
        		sortKey: 'id',
        		sortOrders: sortOrders,
        		tableData: {
        			draw: 0,
        			length: 10,
        			column: 0,
        			dir: 'desc'
        		},
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		auctions: [],
         		errors: [],
         		auction_lots: [],
         		lots: [],
         		buyers: [],
         		lot_id: '',
         		auction_id: '',
         		form: new Form({
        			auction_id: '',
        			name: '',
        			description: '',
        			start_date: '',
        			start_time: '',
        			end_date: '',
        			end_time: '',
        			created_by: this.$userId,
        			updated_by: this.$userId,
        			id: '',
        			total_lots: ''
        		}),

        		status: '',
        		auctionLotStatus: '',
        		alId: '',
        		lot_bids: [],
        		negotiated_price: '',
        		neg_buyer_id: '',
        		bids: [],
        		auto_bids: ''
         }
       },

       methods: {
       	configPagination(data){
      		this.pagination.lastPage=data.lastPage;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
    		},

      	sortBy(key){
     			this.sortKey=key;
      		this.sortOrders[key] = this.sortOrders[key]*-1;
       	  this.tableData.column = this.getIndex(this.columns, 'name', key);
 	     	  this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
    		},

     		getIndex(array, key, value){
       		return array.findIndex(i => i[key] == value)
       	},

       	getAuctions(url="/api/getPastAuctions"){
       		axios.post(url, {params: this.tableData})
       		.then(response => {
       			this.auctions = response.data.data.data;
       			this.configPagination(response.data.data);
       		})
       	},

       	addModal(id){
       		axios.post("/api/getAuctionLots", {id: id})
       		.then(response => {
       			this.auction_lots = response.data;
       		})
       		$("#addModal").modal("show");
       		this.auction_id = id;
       	},

       	details(id){
       		window.open('/home/auction-manager/lot-details/'+id)
       	},

        	alModal(id, status, auction){
        		this.alId = id;
        		this.auctionLotStatus = status;
        		this.auction_id = auction;
        		$("#LotStatusModal").modal("show");
        	},

        	changeAuctionLotStatus(){
        		axios.post("/api/auctionLotChange", {id: this.alId, status: this.auctionLotStatus, auction: this.auction_id})
        		.then(response => {
        			axios.post("/api/getAuctionLots", {id: this.auction_id})
       				.then(response => {
       					this.auction_lots = response.data;
        			})
        			this.getAuctions();
        		})
        	},

        	sellModal(id, status, auction){
        		this.alId = id;
        		this.auctionLotStatus = status;
        		this.auction_id = auction;
        		axios.post("/api/getLotBids", {id: id})
        		.then(response => {
        			this.lot_bids = response.data;
        		})
        		$("#sellLotModal").modal("show");
        	},

        	sell(details){
        		var d = new Date();
						var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
						var nd = new Date(utc + (3600000*+5.5));
        		axios.post("/api/auctionLotChange", {
        			id: this.alId,
        			status: "sold",
        			auction: this.auction_id,
        			bid: details.id
        		})
        		.then(response => {
        			toast.fire({
      	      	type: 'success',
              	title: 'Sold!'
            	});
        			axios.post("/api/getAuctionLots", {id: this.auction_id, auction:true})
       				.then(response => {
       					this.auction_lots = response.data;
        			})
        		})
        	},

        	getBuyers(){
        		axios.post("/api/getBuyers")
        		.then(response => {
        			this.buyers = response.data;
        			for(var i=0; i<this.buyers.length; i++){
        				this.buyers[i].namephone = this.buyers[i].name + '(' + this.buyers[i].mobile + ')';
        			}
        		})
        	},

        	negotiate(g){
        		this.alId = g.id;
        		this.auction_id = g.auction_id;
        		$("#negotiateModal").modal("show");
        	},

        	sellNegotiatedLot(){
        		axios.post("/api/negotiatedSell", {auction_lot: this.alId, auction: this.auction_id, price: this.negotiated_price, buyer: this.neg_buyer_id})
        		.then(response => {
        			toast.fire({
        				title: 'Sold!',
        				type: 'success'
        			});
        			axios.post("/api/getAuctionLots", {id: this.auction_id, auction:true})
       				.then(response => {
       					this.auction_lots = response.data;
        			})
        			this.getAuctions();
        		})
        		.catch(() => {
        			toast.fire({
        				title: 'Failed!',
        				type: 'error'
        			});
        		})
        	},

        	report(id){
        		this.$router.push("/home/auction-manager/auction-report/"+id);
        	},

        	history(id, lot_id){
        		window.open('/home/auction-manager/bid-history/'+id+'/'+lot_id)
       			/*axios.post("/api/showBidsHistory", {id: id})
       			.then(response => {
       				this.bids = response.data;
       				$('#history').modal('show');
       			})*/
       		},

       		autoBidModal(id){
       			axios.post('/api/getAutoBids', {id: id})
       			.then(response => {
       				this.auto_bids = response.data;
       				$("#autoBidModal").modal('show');
       			})

       			axios.post("/api/getLotDetails", {id: lot_id})
        		.then(response => {
        			this.header = response.data.name;
        		})
       		},

       		movedata(){
        		axios.post("/api/movedata")
        		.then(response => {
        			toast.fire({
        				title: 'Sync started ETA 15-30Min',
        				type: 'success'
        			});
        		})
        	},

        	hide(id){
        		axios.post("/api/hideAuction", {id: id})
        		.then(response => {
        			if(response.data == 0){
        				toast.fire({
        					title: 'Auction Hidden',
        					type: 'success'
        				});
        				this.getAuctions();
        			}
        			else
        				toast.fire({
        					title: 'Failed!',
        					type: 'error'
        				});
        		})
        	}
      }
    }
</script>
